export enum FONTS {
  Karla = "'Karla', sans-serif",
  Lora = "'Lora', serif",
}
